import {RoomState} from '../../../../../shared/RoomState'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {UIRoomCenterSettingSpeedType} from './UIRoomCenterSettingsSpeedController'
import {UIPopupController} from '../../../../shared/scripts/ui_popup/UIPopupController'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {EnumUtils} from '../../../../../shared/utils/EnumUtils'
import {StorageWrapper} from '../../../../shared/scripts/StorageWrapper'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {TranslationObject} from '@colonist/i18n'
import {BotSpeedSettings, GameSpeedSettings, RoomSettingConstants} from '@colonist/game-base-types'

export class UIRoomCenterSettingsSpeedView {
    speedInput: HTMLHeadingElement
    speedOptions: (keyof typeof GameSpeedSettings)[]
    speedRightArrow: HTMLImageElement
    speedLeftArrow: HTMLImageElement
    speedDivBody: HTMLDivElement
    speedDiv: HTMLDivElement
    speedInfo: HTMLImageElement
    speedSettings: typeof GameSpeedSettings | typeof BotSpeedSettings
    speedDefaultSetting: keyof typeof GameSpeedSettings
    speedSocketCommand: (value: string) => void

    constructor(type: UIRoomCenterSettingSpeedType) {
        switch(type) {
            case UIRoomCenterSettingSpeedType.GameSpeed: this.initGameSpeedSettings(); break
            case UIRoomCenterSettingSpeedType.BotSpeed: this.initBotSpeedSettings(); break
        }
        this.speedOptions = []
        UIRoomCenterSettingsSpeedView.setSpeedOptions(this.speedSettings, this.speedOptions)
    }

    initGameSpeedSettings() {
        this.speedInput = document.getElementById('room_center_gamespeed_settings_input') as HTMLHeadingElement
        this.speedRightArrow = document.getElementById('gamespeed_settings_right_arrow') as HTMLImageElement
        this.speedLeftArrow = document.getElementById('gamespeed_settings_left_arrow') as HTMLImageElement
        this.speedDivBody = document.getElementById('gamespeed_settings_body') as HTMLDivElement
        this.speedDiv = document.getElementById('room_center_gamespeed_settings') as HTMLDivElement
        this.speedInfo = document.getElementById('gamespeed_settings_speed_info') as HTMLImageElement
        this.speedSettings = GameSpeedSettings
        this.speedDefaultSetting = EnumUtils.getEnumKey(RoomSettingConstants.DEFAULT_GAME_SPEED_SETTING, GameSpeedSettings)
        const speedSocketCommand = (value: string) => {
            StorageWrapper.setRoomGameSpeedSetting(this.speedSettings[value])
            SocketLobbySend.clickedRoomSettingChangeGameSpeed(value)
        }
        this.speedSocketCommand = speedSocketCommand

        this.speedInfo.onclick = () => {
            UIRoomCenterSettingsSpeedView.clickedSpeedInfo()
        }
    }

    private static clickedSpeedInfo() {
        CA.sendGoogleAnalyticsEvent(CA.Category.Room, CA.Label.ClickedRoomGameSpeedInfo)
        const imageAlt = clientI18n.t('strings:roomPage.gameSpeeds')
        const gameSpeedChartImage = `<div class='room-map-preview-grid'><center><img src='/dist/images/room_game_speeds.png?rev=' alt='${imageAlt}' style='width: 70%'></<center>`
        const bodyImage: TranslationObject = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: gameSpeedChartImage,
                interpolation: {
                    escapeValue: false,
                },
            },
        }
        UIPopupController.createSimplePopup({key: 'strings:roomPage.gameSpeeds'}, bodyImage)
    }

    initBotSpeedSettings() {
        this.speedInput = document.getElementById('room_center_botspeed_settings_input') as HTMLHeadingElement
        this.speedRightArrow = document.getElementById('botspeed_settings_right_arrow') as HTMLImageElement
        this.speedLeftArrow = document.getElementById('botspeed_settings_left_arrow') as HTMLImageElement
        this.speedDivBody = document.getElementById('botspeed_settings_body') as HTMLDivElement
        this.speedDiv = document.getElementById('room_center_botspeed_settings') as HTMLDivElement
        this.speedSettings = BotSpeedSettings
        this.speedDefaultSetting = EnumUtils.getEnumKey(RoomSettingConstants.DEFAULT_BOT_SPEED_SETTING, BotSpeedSettings)
        const speedSocketCommand = (value: string) => {
            StorageWrapper.setRoomBotSpeedSetting(this.speedSettings[value])
            SocketLobbySend.clickedRoomSettingChangeBotSpeed(value)
        }
        this.speedSocketCommand = speedSocketCommand
    }

    getSetting(newRoomState: RoomState, type: UIRoomCenterSettingSpeedType): keyof typeof GameSpeedSettings {
        switch(type) {
            case UIRoomCenterSettingSpeedType.GameSpeed: return EnumUtils.getEnumKey(newRoomState.gameSetting.gameSpeed, this.speedSettings)
            case UIRoomCenterSettingSpeedType.BotSpeed: return EnumUtils.getEnumKey(newRoomState.gameSetting.botSpeed, this.speedSettings)
        }
    }

    private static setSpeedOptions(enumName: any, optionsArray: string[]) {
        EnumUtils.loopEnums(enumName, (innerElement, elementNo) => {
            optionsArray.push(enumName[innerElement].toString())
        })
    }
}
